import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";
import { QueryClient } from "@tanstack/react-query";

const { MODE } = import.meta.env;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 0,
      refetchOnWindowFocus: false,
      cacheTime: MODE === "development" ? 0 : 1000 * 60 * 60,
    },
  },
});

export const persister = createSyncStoragePersister({
  key: "QUERY_CACHE",
  storage: window.localStorage,
});

export const persistMutation = (key: string[]) => {
  const persisted = JSON.parse(localStorage.getItem("MUTATION_KEYS") || "[]") || [];

  if (!persisted.includes(key)) {
    persisted.push(key);
    localStorage.setItem("MUTATION_KEYS", JSON.stringify(persisted));
  }
};

export const persistMutationData = <T,>(key: string | string[], data: T): void => {
  localStorage.setItem(`MUTATION_DATA_${key}`, JSON.stringify(data));
};

export const getPersistedMutationData = <T,>(key: string | string[]): T | null => {
  const data = localStorage.getItem(`MUTATION_DATA_${key}`);
  return data ? JSON.parse(data) : null;
};
